import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Label,
  Form,
  FormGroup,
  FormField,
  Dropdown
} from 'semantic-ui-react'

const CardSurgicalPositionUX  = (props: any) => {
    return(
      <div
        id="CardSurgicalPosition"
        style={{ margin: "15px",  padding: "20px",  backgroundColor: "rgba(198, 235, 243, 0.2)" }}>
        <div
          id="CardSurgicalPositionUX_-div-1"
          style={{ paddingBottom: "5px" }}>
          
          <label
            id="CardSurgicalPositionUX_-label-2"
            style={{ fontWeight: "bold", fontSize: "18px" }}>
            {props.languageUX === "en" ? "Surgical Position & Position AID (A)" : "ตำแหน่งการผ่าตัดและตำแหน่ง AID (A)"}
          </label>
          <Label
            color={props.statusColor}
            id="CardSurgicalPositionUX_-Label-3"
            style={{ float: "right" }}>
            {props.status}
          </Label>
          <hr
            id="CardSurgicalPositionUX_-hr-4">
          </hr>
        </div>
        <Form
          id="CardSurgicalPositionUX_-Form-163">
          <FormGroup
            id="CardSurgicalPositionUX_-FormGroup-167"
            inline={true}>
            <FormField
              className="required"
              id="CardSurgicalPositionUX_-FormField-171"
              inline={true}
              width={10}>
              <label
                id="CardSurgicalPositionUX_-label-178"
                style={{minWidth: "120px", maxWidth: "120px"}}>
                Position 
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardSurgicalPositionUX_-Dropdown-182"
                multiple={true}
                name="position"
                onChange={props.handleChangeData}
                options={props.masterOptions?.orSurgicalPosition}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.position}>
              </Dropdown>
            </FormField>
          </FormGroup>
        </Form>
        <Form
          id="CardSurgicalPositionUX_-Form-164">
          <FormGroup
            id="CardSurgicalPositionUX_-FormGroup-168"
            inline={true}>
            <FormField
              className="required"
              id="CardSurgicalPositionUX_-FormField-172"
              inline={true}
              width={10}>
              <label
                id="CardSurgicalPositionUX_-label-175"
                style={{minWidth: "120px", maxWidth: "120px"}}>
                {props.languageUX === "en" ? "Positioning AID" : "ระบบช่วยระบุตำแหน่ง"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardSurgicalPositionUX_-Dropdown-181"
                multiple={true}
                name="device"
                onChange={props.handleChangeData}
                options={props.masterOptions?.orSurgicalDevice}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.device}>
              </Dropdown>
            </FormField>
          </FormGroup>
        </Form>
        <Form
          id="CardSurgicalPositionUX_-Form-165">
          <FormGroup
            id="CardSurgicalPositionUX_-FormGroup-169"
            inline={true}>
            <FormField
              id="CardSurgicalPositionUX_-FormField-173"
              inline={true}
              width={10}>
              <label
                id="CardSurgicalPositionUX_-label-176"
                style={{minWidth: "120px", maxWidth: "120px"}}>
                {props.languageUX === "en" ? "Warmer" : "อุ่นขึ้น"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardSurgicalPositionUX_-Dropdown-180"
                multiple={true}
                name="warmer"
                onChange={props.handleChangeData}
                options={props.masterOptions?.orSurgicalWarmer}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.warmer}>
              </Dropdown>
            </FormField>
          </FormGroup>
        </Form>
        <Form
          id="CardSurgicalPositionUX_-Form-166">
          <FormGroup
            id="CardSurgicalPositionUX_-FormGroup-170"
            inline={true}>
            <FormField
              id="CardSurgicalPositionUX_-FormField-174"
              inline={true}
              width={10}>
              <label
                id="CardSurgicalPositionUX_-label-177"
                style={{minWidth: "120px", maxWidth: "120px"}}>
                {props.languageUX === "en" ? "Circulatory Support" : "การสนับสนุนการไหลเวียนโลหิต"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardSurgicalPositionUX_-Dropdown-179"
                multiple={true}
                name="circulator_support"
                onChange={props.handleChangeData}
                options={props.masterOptions?.orSurgicalCirculatory}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.circulatorSupport}>
              </Dropdown>
            </FormField>
          </FormGroup>
        </Form>
        <div
          style={{width: "100%"}}>
          {props.nursingDiagnosisItem}
        </div>
        <div
          id="CardSurgicalPositionUX_-div-154"
          style={{ height: "55px", paddingTop: "15px" }}>
          
          <div
            id="CardSurgicalPositionUX_-div-155"
            style={{display:"flex",justifyContent:"flex-end"}}>
            
            <div
              id="CardSurgicalPositionUX_-div-160"
              style={{margin:"10px"}}>
              {props.buttonSave}
            </div>
            <div
              id="CardSurgicalPositionUX_-div-161"
              style={{margin:"10px"}}>
              {props.buttonConfirm}
            </div>
            <div
              id="CardSurgicalPositionUX_-div-162"
              style={{margin:"10px"}}>
              {props.buttonUnconfirm}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardSurgicalPositionUX 

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:52 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalPosition"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\",  padding: \"20px\",  backgroundColor: \"rgba(198, 235, 243, 0.2)\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"5px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำแหน่งการผ่าตัดและตำแหน่ง AID (A)",
          "valueEN": "Surgical Position & Position AID (A)"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-label-2"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"18px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Label",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.status"
        },
        "color": {
          "type": "code",
          "value": "props.statusColor"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-Label-3"
        },
        "style": {
          "type": "code",
          "value": "{ float: \"right\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-hr-4"
        }
      },
      "seq": 4,
      "void": true
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-div-154"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"55px\", paddingTop: \"15px\" }"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-div-155"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",justifyContent:\"flex-end\"}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 160,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-div-160"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirm"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-div-161"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUnconfirm"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-div-162"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 163,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-Form-163"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-Form-164"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-Form-165"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-Form-166"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "FormGroup",
      "parent": 163,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-FormGroup-167"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 168,
      "name": "FormGroup",
      "parent": 164,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-FormGroup-168"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 169,
      "name": "FormGroup",
      "parent": 165,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-FormGroup-169"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 170,
      "name": "FormGroup",
      "parent": 166,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-FormGroup-170"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 171,
      "name": "FormField",
      "parent": 167,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-FormField-171"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 172,
      "name": "FormField",
      "parent": 168,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-FormField-172"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 173,
      "name": "FormField",
      "parent": 169,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-FormField-173"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 174,
      "name": "FormField",
      "parent": 170,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-FormField-174"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "label",
      "parent": 172,
      "props": {
        "children": {
          "type": "value",
          "value": "ระบบช่วยระบุตำแหน่ง",
          "valueEN": "Positioning AID"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-label-175"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"120px\", maxWidth: \"120px\"}"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "label",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": "อุ่นขึ้น",
          "valueEN": "Warmer"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-label-176"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"120px\", maxWidth: \"120px\"}"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "label",
      "parent": 174,
      "props": {
        "children": {
          "type": "value",
          "value": "การสนับสนุนการไหลเวียนโลหิต",
          "valueEN": "Circulatory Support"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-label-177"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"120px\", maxWidth: \"120px\"}"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "label",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": "Position "
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-label-178"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"120px\", maxWidth: \"120px\"}"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 179,
      "name": "Dropdown",
      "parent": 174,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-Dropdown-179"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "circulator_support"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.orSurgicalCirculatory"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.circulatorSupport"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 180,
      "name": "Dropdown",
      "parent": 173,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-Dropdown-180"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "warmer"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.orSurgicalWarmer"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.warmer"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 181,
      "name": "Dropdown",
      "parent": 172,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-Dropdown-181"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "device"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.orSurgicalDevice"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.device"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 182,
      "name": "Dropdown",
      "parent": 171,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalPositionUX_-Dropdown-182"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "position"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.orSurgicalPosition"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.position"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 195,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.nursingDiagnosisItem"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 166,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardSurgicalPositionUX ",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
